var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSugar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9688_1738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.62756 6.06504C8.21561 6.21642 7.76326 6.21642 7.35131 6.06504L1.14256 3.59879C0.796557 3.44729 0.796557 3.25279 1.14256 3.09879L7.37256 0.613539C7.78451 0.462154 8.23686 0.462154 8.64881 0.613539L14.8576 3.08004C15.2036 3.23154 15.2036 3.42604 14.8576 3.58004L8.62756 6.06504Z",
    fill: "#E22329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80492 16.0158C7.82667 16.2321 7.67492 16.4483 7.45892 16.4918C7.37242 16.5136 7.26392 16.4918 7.19942 16.4486L0.969416 13.9391C0.601916 13.7661 0.363666 13.4198 0.341916 13.0306V4.42106C0.320166 4.20481 0.471916 3.98856 0.687916 3.94506C0.774416 3.92331 0.882916 3.94506 0.947416 3.98831L7.17742 6.47581C7.54492 6.64881 7.78317 6.99506 7.80492 7.38431V16.0158Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19494 16.0155C8.17319 16.2318 8.32494 16.448 8.54094 16.4915C8.62744 16.5133 8.73594 16.4915 8.80044 16.4483L15.0304 14.0038C15.3979 13.8308 15.6362 13.4845 15.6579 13.0953V4.46403C15.6797 4.24778 15.5279 4.03153 15.3119 3.98803C15.2254 3.96628 15.1169 3.98803 15.0524 4.03128L8.82244 6.51878C8.45494 6.69178 8.21669 7.03803 8.19494 7.42728V16.0155Z",
    fill: "#929497"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9688_1738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSugar);
export default __webpack_public_path__ + "static/media/sugar.9e7fc4e7422ace6bf9ec2d4f728b5cb4.svg";
export { ForwardRef as ReactComponent };